const MenuFindStore = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <g clipPath="url(#mobile-menu-store-clip)">
            <path
                d="M20.9936 10.3394C21.1232 11.2373 18.7185 12.1892 16.9554 10.5892C16.1387 11.6153 14.1293 11.9056 12.3857 10.6162C11.9903 11.0752 10.8755 11.4533 9.9356 11.433C9.1189 11.4195 8.30219 11.1225 7.6929 10.5554C6.40301 11.9934 2.68893 11.7571 3.01951 10.2314C3.36953 8.61785 4.54273 4.01363 4.82793 4.00013C5.11962 3.98663 18.0897 4.13515 18.4397 4.19591C18.7898 4.25667 20.9093 9.73853 20.9936 10.3394Z"
                fill="#534E46"
            />
            <path
                d="M20.1768 19.3586C20.1833 19.4801 20.1833 19.6151 20.1185 19.7231C19.9499 19.9864 17.2146 19.8919 16.5859 19.9122C16.0673 19.9257 14.4598 20.0269 14.3302 19.9392C14.2459 19.8784 14.9849 15.0717 11.906 15.1459C8.82715 15.2202 10.2337 19.8447 10.0133 19.9864C9.89016 20.0674 4.09542 19.8852 4.04357 19.8312C3.99819 19.7839 4.22506 12.8911 4.22506 12.8911C5.34641 13.1274 6.94094 12.8573 7.69931 12.0134C8.3086 12.5873 9.12531 12.8776 9.94202 12.8911C10.8754 12.9113 11.9968 12.5333 12.3921 12.0742C14.1358 13.3636 16.1516 13.0733 16.9618 12.0472C17.973 12.9653 20.0277 12.7763 20.0277 12.7763C20.0277 12.7763 20.099 16.9755 20.1768 19.3586Z"
                fill="#534E46"
            />
        </g>
        <defs>
            <clipPath id="mobile-menu-store-clip">
                <rect
                    width="18"
                    height="16"
                    fill="white"
                    transform="translate(3 4)"
                />
            </clipPath>
        </defs>
    </svg>
)

export default MenuFindStore
